/**
 * Whether this window shows its wall (Part 06 decisions 2 and 6): today's
 * canvas visibility rule (`components/layout/desktop-layout-visibility.ts`)
 * without the compact-overlay exception. On desktop the wall hides in
 * compact mode, also while compact focus makes `canvas-area` visible; the
 * web has no compact mode.
 */
import { isTauri } from "@/lib/is-tauri";
import { useDesktopMode, type DesktopMode } from "@/stores/desktop-mode-store";

function wallVisibleIn(mode: DesktopMode): boolean {
  return !isTauri() || mode !== "compact";
}

export function wallVisibleHere(): boolean {
  return wallVisibleIn(useDesktopMode.getState().mode);
}

/** `wallVisibleHere()`, re-rendering when the desktop mode changes. */
export function useWallVisibleHere(): boolean {
  return wallVisibleIn(useDesktopMode((state) => state.mode));
}
